import type { SharingLevelVariantType } from './types';

export const SHARING_LEVEL_VARIANT_LABEL: Record<
  SharingLevelVariantType,
  string
> = {
  all: 'All',
  overlaps: 'Overlaps',
  counts: 'Counts',
  hidden: 'Hidden',
  request: 'Request',
  pending: 'Pending',
};
